/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cat_Pazaryerleri_TitleInputs */

const tr_faq_cat_pazaryerleri_title = /** @type {(inputs: Faq_Cat_Pazaryerleri_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryerleri`)
};

const en_faq_cat_pazaryerleri_title = /** @type {(inputs: Faq_Cat_Pazaryerleri_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces`)
};

const de_faq_cat_pazaryerleri_title = /** @type {(inputs: Faq_Cat_Pazaryerleri_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkaufsplattformen`)
};

const ru_faq_cat_pazaryerleri_title = /** @type {(inputs: Faq_Cat_Pazaryerleri_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадки`)
};

/**
* | output |
* | --- |
* | "Marketplaces" |
*
* @param {Faq_Cat_Pazaryerleri_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_cat_pazaryerleri_title = /** @type {((inputs?: Faq_Cat_Pazaryerleri_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cat_Pazaryerleri_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_cat_pazaryerleri_title(inputs)
	if (locale === "de") return de_faq_cat_pazaryerleri_title(inputs)
	if (locale === "ru") return ru_faq_cat_pazaryerleri_title(inputs)
	return tr_faq_cat_pazaryerleri_title(inputs)
});